import { render, staticRenderFns } from "./introdetail.vue?vue&type=template&id=da6a759c&scoped=true&"
import script from "./introdetail.vue?vue&type=script&lang=js&"
export * from "./introdetail.vue?vue&type=script&lang=js&"
import style0 from "./introdetail.vue?vue&type=style&index=0&id=da6a759c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6a759c",
  null
  
)

export default component.exports